import { withStyles } from '@material-ui/core';
import React from 'react'; // eslint-disable-line
import { ExpansionPanel } from '../../../../forms/form-components/expansion-panel/expansion-panel';
import styles, { StyledComponent } from '../../../../styles/styles';
import { ClaimantDetailsView } from './views/claimant-details/claimant-details-view';
import { LifeAssuredDetailsView } from './views/life-assured-details/life-assured-details-view';
import { PolicyHolderDetailsView } from './views/policy-holder-details/policy-holder-view';
import { PaymentDetailsView } from './views/payment-details/payment-details-view';
import { connect } from 'react-redux';
import { State } from '../../../../redux/root-reducer';
import { ClaimReference, getReferences } from '../../../../claim/reducers/claim-reference-reducer';
import { FormDetails, getFormDetails, getFormDetailsList } from './form-details-reducer';
import { DeclarationInformationView } from './views/declaration/declaration-view';
import { Claim, getClaim } from '../../../../claim';
import { Nullable } from '../../../../shared-types';
import { ClaimType } from '../../../../claim/claim-types';
import { EmploymentGroupView } from './views/employment-details/employment-details-view';
import { ClaimTypeDetailsView } from './views/claim-type-details/claim-type-view';
import { RetrenchmentDeclarationInformationView } from '../../retrenchment/form-details/views/declaration/declaration-view';

interface Props extends StyledComponent {
    lifeAssuredDetails: FormDetails[];
    lifeAssuredForm: FormDetails;
    isUnderWriting?: boolean;
    references: ClaimReference[];
    claimType?: Nullable<ClaimType>;
    claim: Claim;
}

const formDetailsView: React.FunctionComponent<Props> = ({
    classes,
    lifeAssuredDetails,
    lifeAssuredForm,
    isUnderWriting,
    references,
    claimType,
    claim,
}: Props) => {
    if (!claim.forms || claim.forms.length === 0) {
        return null;
    }

    let benefitClaimTypes: string | string[] | undefined;
    let isPaymentViewAvailable = true;
    if (lifeAssuredDetails.length === 0 && lifeAssuredForm) {
        lifeAssuredDetails = [lifeAssuredForm];
        benefitClaimTypes = lifeAssuredForm.claimType;

        if (
            claimType === ClaimType.Retrenchment &&
            benefitClaimTypes?.length === 1 &&
            benefitClaimTypes?.includes('Retrenchment Premium Waiver')
        ) {
            isPaymentViewAvailable = false;
        }
    }
    return (
        <>
            {lifeAssuredDetails.length > 0 && (
                <ExpansionPanel
                    name="Form Details"
                    label={
                        <>
                            <span>Form Details</span>

                            {!claim.canShowFormDetails && (
                                <span
                                    style={{
                                        marginLeft: 8,
                                        color: '#161616',
                                        fontSize: '0.75rem',
                                        fontWeight: 400,
                                    }}
                                >
                                    (Some fields may appear blank because this claim was submitted
                                    using a different form. All details are available in
                                    {'Claimant Statement'}.)
                                </span>
                            )}
                        </>
                    }
                >
                    {references.map((reference, referenceIndex) => {
                        const panelName = `Form ${referenceIndex + 1} - Case ${
                            reference.referenceId
                        }`;
                        const formDetail =
                            references.length === 1
                                ? lifeAssuredForm
                                : lifeAssuredDetails[referenceIndex];

                        if (
                            formDetail &&
                            formDetail.lifeAssured &&
                            formDetail.lifeAssured?.medicalAidDetails
                        ) {
                            formDetail.lifeAssured.medicalAidDetails.hasMedicalAid =
                                formDetail.lifeAssured?.medicalAidDetails
                                    ?.lifeAssuredMedicalAidNumber ||
                                formDetail.lifeAssured?.medicalAidDetails?.lifeAssuredMedicalAidName
                                    ? 'Yes'
                                    : 'No';
                        }

                        return (
                            <ExpansionPanel
                                name={`${panelName}`}
                                label={panelName}
                                key={`form${referenceIndex}`}
                                style={{ marginLeft: -16, marginRight: -16 }}
                                {...(!claim.canShowFormDetails && { notifier: 'Information' })}
                            >
                                <ClaimTypeDetailsView formDetails={formDetail} />

                                <ClaimantDetailsView
                                    formDetails={formDetail}
                                    disableEditButton={true}
                                />
                                <PolicyHolderDetailsView
                                    formDetails={formDetail}
                                    disableEditButton={true}
                                    claimType={claimType}
                                />
                                <LifeAssuredDetailsView
                                    formDetails={formDetail}
                                    disableEditButton={true}
                                    claimType={claimType}
                                />
                                {claimType !== ClaimType.TerminalIllness && (
                                    <EmploymentGroupView
                                        formDetails={formDetail}
                                        disableEditButton={true}
                                    />
                                )}
                                {isPaymentViewAvailable && (
                                    <PaymentDetailsView
                                        formDetails={formDetail}
                                        disableEditButton={true}
                                    />
                                )}
                                {claimType === ClaimType.Retrenchment ? (
                                    <RetrenchmentDeclarationInformationView
                                        formDetails={formDetail}
                                    />
                                ) : (
                                    <DeclarationInformationView
                                        formDetails={formDetail}
                                        disableEditButton={true}
                                    />
                                )}
                            </ExpansionPanel>
                        );
                    })}
                </ExpansionPanel>
            )}
        </>
    );
};

const mapStateToProps = (state: State) => ({
    lifeAssuredDetails: getFormDetailsList(state),
    lifeAssuredForm: getFormDetails(state),
    references: getReferences(state),
    claimType: getClaim(state).claimType,
    claim: getClaim(state),
});

export default connect(mapStateToProps, {})(withStyles(styles)(formDetailsView));
